// src/components/InfoContainer/VerticalInfoContainer.js
import React from 'react';
import InfoCard from '../InfoCard/InfoCard';
import houseIcon from '../../../assets/svg/icon/edc-info-house-white.svg';
import handShakeIcon from '../../../assets/svg/icon/edc-info-handshake-white.svg';
import routeIcon from '../../../assets/svg/icon/edc-info-route-white.svg';
import lightIcon from '../../../assets/svg/icon/edc-info-light-white.svg';
import './VerticalInfoContainer.css';

const VerticalInfoContainer = () => {
  const backgroundColor = 'transparent';
  const headingColor = '#FF872F';
  const headingSize = '';
  const cardWidth = '400px';

  return (
    <div className="vertical-info-container-wrapper-for-creator">
      <div className="vertical-info-container-for-creator">
        <InfoCard
          image={lightIcon}
          heading="A NEW WAY TO MONETISE YOUR CONTENT"
          text="Our innovative approach is a new way to monetize your content.  Whether you're an established creator or just starting out on your journey."
          backgroundColor={backgroundColor}
          headingColor={headingColor}
          headingSize={headingSize}
          infoCardWidth={cardWidth}
        />
        <InfoCard
          image={houseIcon}
          heading="IMMEDIATE ACCESS TO LIVE BRAND ACTIVATIONS"
          text="We have live brand activations on the platform, which you can access immediately."
          backgroundColor={backgroundColor}
          headingColor={headingColor}
          headingSize={headingSize}
          infoCardWidth={cardWidth}
        />
        <InfoCard
          image={handShakeIcon}
          heading="COMMUNITY POWERED GROUP TRAINING"
          text="We provide bootcamps and tips/tricks around how to produce awesome content.Further details shared on our WhatsApp group."
          backgroundColor={backgroundColor}
          headingColor={headingColor}
          headingSize={headingSize}
          infoCardWidth={cardWidth}
        />
        <InfoCard
          image={routeIcon}
          heading="ADD THE BIGGEST BRANDS TO YOUR PORTFOLIO"
          text="We work with the biggest brands in the World, and give you the access."
          backgroundColor={backgroundColor}
          headingColor={headingColor}
          headingSize={headingSize}
          infoCardWidth={cardWidth}
        />
      </div>
    </div>
  );
};

export default VerticalInfoContainer;
